module.exports = {
  baseApiUrl: "https://apihomolog.blumar.com.br/",
  baseWebserviceUrl: "https://apihomolog.blumar.com.br/",
  creditCardEnv: "DEV",
  paymentActive: false,
  cancellationTax: '3,5',
  omnibeesEnabled: false,
  blumarCdn: "cdn-homolog",
};



// WEBPACK FOOTER //
// ./blumar-development.config.js